<template>
    <div id="impressum">
        <ruth-header :tickets="false"></ruth-header>
        <div id="container" class="nobackgroundimg">
            <div id="content">
                <h1 class="ticketsheading">TICKETS</h1>
                <h2>Leider ist der Online-Ticketverkauf schon vorbei. Es sind jedoch noch Tickets an der Abendkassa erhältlich.</h2>
            </div>
            <social-media></social-media>
            <ruth-footer></ruth-footer>
        </div>
    </div>
</template>

<script>
    import ruthHeader from './GlobalSegments/Header'
    import socialMedia from './GlobalSegments/SocialMedia'
    import ruthFooter from './GlobalSegments/Footer'

    export default {
        name: 'TooLate',
        components: {
            ruthHeader,
            socialMedia,
            ruthFooter
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/TooLate.vue